<!--
 * @Author: liukai
 * @since: 2022-04-13 14:44:14
 * @LastAuthor: liukai
 * @lastTime: 2022-04-20 11:51:23
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<style>
body {
  font-size: 16px;
  background-color: #f8f8f8;
  -webkit-font-smoothing: antialiased;
}
</style>
